import React from 'react';
import styled from '../../../../../lib/styles';
import Spacer from '../../../../../components/presentational/Spacer';
import insuranceBlockStyles from './InsuranceBlock_styles';
import Button from '../../../../../components/presentational/Button';
import Icon from '../../../../../components/presentational/Icon';

interface InsuranceBlockProduct {
  product_code: string;
  button_label: string;
};

export interface InsuranceBlockData {
  type: 'open_insurance_block';
  product_codes: InsuranceBlockProduct[];
}

export interface InsuranceBlockProps {
  block: InsuranceBlockData;
}

const openInsuranceSDK = async (product: InsuranceBlockProduct, openSDK: any) => {
  const { product_code } = product;
  const portalUrl = product_code === 'hud-compare-home' ? `${process.env.OPEN_HOME_PORTALURL}` : `${process.env.OPEN_PORTALURL}`;
  const apiEndpoint = process.env.OPEN_APIENDPOINT;

  const loadSDK = new Promise((loaded, failed) => {
    try {
      loaded(
        openSDK.load(
          process.env.OPEN_APIKEY,
          {
            apiEndpoint,
            portalUrl
          }
        )
      )
    } catch (e) {
      console.error('Error loading OpenSDK', e);
      failed(e);
    }
  });

  return loadSDK
    .then(async () => await openSDK.quote.prepare(product_code, null, {}))
    .then(async (quote) => {
      console.log('Insurance quote execute', {product, quote});
      let options = { redirect: window.location.href, redirectBack: window.location.origin }; 
      await openSDK.quote.portal(quote.product_code, quote.quote_ref, options);
    })
    .catch((error) => console.error('Error executing OpenSDK', error))
}

const InsuranceBlock = ({ block: { product_codes }, styles }) => {
  // console.log({ product_codes }, 'InsuranceBlock');
  return (
    <div className={`insurance-block ${styles.container}`}>
      <Spacer width={1160} space={['m', 'l']}>
        {product_codes.map((product: InsuranceBlockProduct, key) => {
          const { button_label, product_code } = product;
          const icon = product_code === 'cmp-hdl-car' ? 'las la-car-side' : 
            product_code === 'cmp-hdl-travel' ? 'las la-globe' :
            product_code === 'hud-compare-home' ? 'las la-home' : null;

          return (
            <div
              key={key}
              className={`insurance-block-item ${styles.blockItem}`}
            >
              <Button
                key={button_label}
                type={'button'}
                color={'primary'}
                disabled={false}
                className={'insurance-block-item-button'}
                onClick={async () => window && window.opensdk && 
                  await openInsuranceSDK(product, window.opensdk)
                  .catch((e) => console.error('Error opening Insurance SDK', e))
                }
              >
                {icon && <Icon className={`mr-3 ${icon}`} icon={null} />}
                {button_label}
              </Button>
            </div>
          );
        })}
      </Spacer>
    </div>
  );
};

export default styled(insuranceBlockStyles)(InsuranceBlock);
